import graphql from 'babel-plugin-relay/macro';
import { useMutation } from 'react-relay';

import { CreateCustomerMutation } from './__generated__/CreateCustomerMutation.graphql';

const createCustomerMutation = graphql`
  mutation CreateCustomerMutation(
    $key: String!
    $name: String!
    $categoryId: ID
    $address: String
    $address2: String
    $city: String
    $state: String
    $zip: String
    $status: String
  ) {
    createCustomer(
      input: {
        key: $key
        name: $name
        categoryId: $categoryId
        address: $address
        address2: $address2
        city: $city
        state: $state
        zip: $zip
        status: $status
      }
    ) {
      id
      key
      name
      categoryId
      address
      address2
      city
      state
      zip
      status
    }
  }
`;

const useCreateCustomerMutation = () =>
  useMutation<CreateCustomerMutation>(createCustomerMutation);

export { useCreateCustomerMutation };
